// this file was auto-generated by yo breck:model

export enum AppointmentTypes {
    TestSample = 1,
    InterviewZoom = 2,
    InterviewInPerson = 3,
}
